import axiosClient from "../axios/axiosClient";

export function getIndustryCollaborations() {
  return axiosClient.get("/industry-collaborations");
}

export function getIndustryCollaboration(collaborationId) {
  return axiosClient.get(`/industry-collaborations/${collaborationId}`);
}

export function createIndustryCollaboration(data) {
  return axiosClient.post("/industry-collaborations", data);
}

export const updateIndustryCollaboration = (collaborationId, data) => {
  return axiosClient.put(`/industry-collaborations/${collaborationId}`, data);
};

export function deleteIndustryCollaboration(collaborationId) {
  return axiosClient.delete(`/industry-collaborations/${collaborationId}`);
}
